import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { Menu } from 'semantic-ui-react';

class TopMenu extends Component {
  state = {};

  render() {
    return (
      <Menu fixed="top" inverted>
        <Menu.Item as={NavLink} exact to="/" content="Home" />
        <Menu.Item as={NavLink} to="/About" content="About" />
        <Menu.Item as={NavLink} to="/Contact" content="Contact" />
      </Menu>
    );
  }
}

export default withRouter(TopMenu);



// WEBPACK FOOTER //
// ./src/components/TopMenu.js